// src/pages/PartnerFlow.js

import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE } from "../api";
import LogoTransition from "../components/LogoTransition";

const PROMPTS = [
  {
    id: 1,
    text:
      "Who are you?\n\n" +
      "Take a moment to describe yourself as a person - good and bad.\n" +
      "What defines you, beyond roles and expectations?"
  },
  {
    id: 2,
    text:
      "Now, describe your partner as a person.\n\n" +
      "How do you see them — their nature, their strengths, their struggles?\n" +
      "Who are they, in your eyes, beyond the relationship?"
  }
];

export default function PartnerFlow() {

  const { sessionId, role } = useParams();
  const navigate = useNavigate();

  const [step, setStep] = useState(0);
  const [answer, setAnswer] = useState("");

  const [typed, setTyped] = useState("");
  const [charIndex, setCharIndex] = useState(0);

  const [showTransition, setShowTransition] = useState(false);
  const [pendingStep, setPendingStep] = useState(null);

  const current = PROMPTS[step];

  useEffect(() => {
    setTyped("");
    setCharIndex(0);
  }, [step]);

  useEffect(() => {

    if (!current) return;

    if (charIndex < current.text.length) {

      const t = setTimeout(() => {
        setTyped(prev => prev + current.text[charIndex]);
        setCharIndex(i => i + 1);
      }, 34);

      return () => clearTimeout(t);
    }

  }, [charIndex, current]);

  useEffect(() => {

    if (!showTransition) return;

    const t = setTimeout(() => {

      setShowTransition(false);

      if (pendingStep === "next") {
        setStep(s => s + 1);
      }

      if (pendingStep === "end") {
        navigate(`/wait/${sessionId}/${role}`);
      }

      setPendingStep(null);

    }, 4800);

    return () => clearTimeout(t);

  }, [showTransition, pendingStep, navigate, sessionId, role]);

  async function next() {

    if (!answer.trim()) return;

    await fetch(`${API_BASE}/save_answer`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        session_id: sessionId,
        role,
        message: answer.trim()
      })
    });

    setAnswer("");

    if (step + 1 < PROMPTS.length) {
      setPendingStep("next");
      setShowTransition(true);
    } else {
      setPendingStep("end");
      setShowTransition(true);
    }
  }

  if (showTransition) {
    return <LogoTransition />;
  }

  return (

    <div
      className="fade-in"
      style={{
        minHeight: "100vh",
        background:
          "radial-gradient(circle at 50% 45%, #123044 0%, #081822 55%, #020608 100%)",
        paddingTop: 80
      }}
    >

      <div
        className="card"
        style={{
          maxWidth: 560,
          margin: "0 auto",
          background: "rgba(18,48,68,0.35)",
          border: "1px solid rgba(245,244,237,0.25)",
          backdropFilter: "blur(8px)"
        }}
      >

        <p
          style={{
            fontFamily: "Cormorant Garamond, serif",
            fontSize: 16,
            fontWeight: 300,
            lineHeight: 1.9,
            letterSpacing: "0.04em",
            color: "#F5F4ED",
            whiteSpace: "pre-wrap",
            minHeight: 320,
            marginBottom: 24
          }}
        >
          {typed}
        </p>

        <textarea
          className="input"
          rows={8}
          value={answer}
          onChange={e => setAnswer(e.target.value)}
        />

        <div style={{ marginTop: 24, textAlign: "right" }}>

          <button className="btn btn-primary" onClick={next}>
            {step + 1 === PROMPTS.length ? "Finish" : "Continue"}
          </button>

        </div>

      </div>

    </div>
  );
} 
